import React from "react";
import { Link } from "react-router-dom";
import homeBanner from "../../assets/home-loan-banner.jpg";
import "./LoanProduct.css";

const HomeLoan = () => {
  return (
    <main className="loan-page">
      <section className="loan-hero" style={{ backgroundImage: `url(${homeBanner})` }}>
        <div className="loan-hero-inner cb-rise">
          <h1>Your home starts with the right lending partner</h1>
          <p>
            Core Bankers connects you with RBI-registered banks and NBFCs for home loans.
            We guide the process — we do not lend.
          </p>
          <Link to="/eligibility" className="cb-btn">
            Check Eligibility
          </Link>
        </div>
      </section>

      <div className="loan-content">
        <section className="loan-section">
          <h2>Why choose Core Bankers</h2>
          <ul>
            <li>Access to lenders offering competitive home loan rates</li>
            <li>Zero service charges from our side</li>
            <li>Guidance on eligibility, documentation, and lender selection</li>
            <li>Support for salaried, self-employed, and first-time buyers</li>
            <li>Faster coordination through our DSA network</li>
          </ul>
        </section>

        <section className="loan-section">
          <h2>Eligibility criteria</h2>
          <ul>
            <li>Applicant typically between 21 and 65 years</li>
            <li>Minimum income as per lender policy</li>
            <li>Stable employment or business history</li>
            <li>Valid PAN, Aadhaar, and address proof</li>
            <li>Good credit score (650+ preferred)</li>
          </ul>
        </section>

        <section className="loan-section">
          <h2>Documents required</h2>
          <ul>
            <li>PAN Card and Aadhaar Card</li>
            <li>Income proof (salary slips / ITRs)</li>
            <li>Bank statements (last 6 months)</li>
            <li>Property documents (sale deed, agreement, etc.)</li>
            <li>Address proof and passport-size photo</li>
          </ul>
        </section>

        <section className="loan-section">
          <h2>How it works</h2>
          <ol>
            <li>Submit your home loan enquiry</li>
            <li>We assess your profile and property details</li>
            <li>Lenders are matched based on eligibility</li>
            <li>Loan is disbursed directly by the lender</li>
          </ol>
        </section>

        <section className="loan-cta">
          <h2>Plan your home finance with clarity</h2>
          <p>From eligibility to disbursal — Core Bankers is your DSA partner across lenders.</p>
          <Link to="/eligibility" className="cb-btn">
            Get Started
          </Link>
        </section>
      </div>
    </main>
  );
};

export default HomeLoan;
